import { useState } from "preact/hooks"
import '../styles/formBuilder.css';


export const BoothFollowUp = ({ apiURL, formItems, boothId}) => {

    const [object, setObject] = useState({})
    const [submitted, setSubmitted] = useState(false)

    function updateObject(fieldName) {

        return function(e) {
            setObject( prevState => {

                return {
                    ...prevState, [fieldName] : e.target.value
                }
            })
        }
    }

    let formLabels = {
        name: 'Full Name',
        email: 'Email',
        company: 'Company',
        title: 'Job Title'
    }

    async function submitForm(e) {

        e.preventDefault()

        const { name, email, company, title, other } = object 

        let data = {
            boothId,
            name,
            email,
            company,
            job: title,
            otherName: formItems.other || undefined ,
            other: other
        }
        
        await fetch( apiURL + '/api/booth/contact', {
            method: "POST",
            mode: 'no-cors',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
            },
            cache: "default",
            body: JSON.stringify(data),
          }).catch((error) => {console.log(error); throw error})

        setSubmitted(true)
    }

    if (submitted) {
        return (
            <h1>Thank you for your submission!</h1>
        )
    }

    return (
        <div className="form-container">
            <form className="form" onSubmit={submitForm}>
                <h3>Fill out the form below, and hit submit to contact the booth owner!</h3>
                {Object.keys(formItems).map(key => {
                    if(formItems[key] !== false) {
                        return  <div className="wrapper">
                            <input className="form-input" placeholder={key === 'other' ? formItems[key] : formLabels[key]} type={key === 'email' ? key : 'text' } required={key === 'email' || key === 'name'}  onChange={updateObject(key)} ></input>
                         </div>
                             
                }})}

                <input className="form-submit" type='submit' ></input>
            </form>
        </div>
    )


}